var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout reference-clients" },
    [
      _c("div", { staticClass: "reference-clients-title" }, [
        _vm._v("Клиенты"),
      ]),
      _c("div", { staticClass: "reference-clients-filters" }, [
        _c(
          "div",
          { staticClass: "reference-clients-filters-fields" },
          [
            _c("c-input", {
              staticClass: "reference-clients-filters-fields-type",
              attrs: {
                label: "Тип клиента",
                type: "select",
                clearable: true,
                items: _vm.filters.customerTypeItems,
                placeholder: "Все",
              },
              model: {
                value: _vm.filters.customerType,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "customerType", $$v)
                },
                expression: "filters.customerType",
              },
            }),
            _c("c-input", {
              staticClass: "reference-clients-filters-fields-search-text",
              attrs: {
                "placeholder-style": "italic",
                icon: "search",
                type: "text",
                clearable: true,
                placeholder: "Поиск по ФИО, телефону, email",
              },
              model: {
                value: _vm.filters.search,
                callback: function ($$v) {
                  _vm.$set(_vm.filters, "search", $$v)
                },
                expression: "filters.search",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "reference-clients-filters-buttons" },
          [
            _c("c-button", {
              staticClass: "reference-clients-filters-buttons-apply",
              attrs: { label: "Применить", color: "primary" },
              on: { click: _vm.applyFilters },
            }),
            _c("c-button", {
              staticClass: "reference-clients-filters-buttons-reset",
              attrs: { label: "Сбросить" },
              on: { click: _vm.resetFilters },
            }),
          ],
          1
        ),
      ]),
      !_vm.isTableLoading
        ? _c(
            "div",
            { staticClass: "reference-clients-table" },
            [
              _c("c-data-table-reference-clients", {
                ref: "tableReferenceClients",
                staticClass: "reference-clients-table-table",
                attrs: {
                  "sorted-column": _vm.tableData.sortedColumn,
                  levels: 1,
                  "empty-records-label": "Записи не найдены",
                  "disabled-columns": [],
                  data: _vm.tableData,
                },
                on: { sortedEvent: _vm.refreshTable },
              }),
              _vm.isLoadingData
                ? _c("c-loader", {
                    attrs: {
                      label: "Загрузка данных",
                      active: _vm.isLoadingData,
                      height: "150",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.isTableLoading
        ? _c("c-loader", {
            staticClass: "reference-clients-loader",
            attrs: {
              label: "Загрузка списка клиентов",
              active: _vm.isTableLoading,
              height: "500",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }